<template>
  <div class="indexActivity" data-aos="fade-up" data-aos-duration="1550" data-aos-anchor-placement="top-bottom">
    <div class="activity-title">
      <h5 v-if="lang!='en'">Activity Photos</h5>
      <h3>{{ $t('INDEX.ACTIVITYPHOTOS') }}</h3>
    </div>
    <div class="detailed-con" v-if="datas.length == 0" >
        <div class="oops">
            <img src="../../../../static/images/10/oops.png" alt="">
        </div>
    </div>
    <ul class="autoplay indexActivityBox"  v-if="datas.length > 0">
      <li v-for="(item) in datas" :key="item.id" >
        <a :href="'/activity/'+item.id">
          <div class="Activityimg" :style="{ 'background-image': 'url('+ item.data.src+')' }">
          </div>
          <div class="Activitytxt">
            <h5>{{item.data.title}}</h5>
            <p class="time">{{item.data.date}}</p>
          </div>
        </a>
      </li>
    </ul>
    <a class="all" href="/activity">view all</a>
  </div>
</template>
<script>
import {fb, db } from '../../../firebase'
export default {
  name: 'IndexActivity',
  data () {
    return {
      datas:[],
      lang:''
    }
  },
  mounted () {
    this.lang = localStorage.getItem('language') || 'zh';
    this.Get();
  },
  methods: {
    Get(){
      // 取得列表
      db.collection(this.$t('DB.ACTIVITY')).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              var data = {"id": doc.id, "data": doc.data()};
              
              this.datas.push(data);
          });
          this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);
          setTimeout(function(){
              $('.autoplay').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                responsive: [
                  {
                    breakpoint: 1250,
                    settings: {
                      centerMode: true,
                      slidesToShow: 2
                    }
                  },
                  {
                    breakpoint: 780,
                    settings: {
                      
                      slidesToShow: 1
                      
                    }
                  }
                ]
              });
          }, 200)
        
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/Module/Activity.vue